import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Type } from '@uswitch/spark';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var LinkListItem = function LinkListItem(_ref) {
  var href = _ref.href,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx("li", _objectSpread(_objectSpread({
    sx: {
      color: ['grey-100', null, 'grey-80'],
      marginBottom: '16px',
      '&::after': {
        content: '"|"',
        color: 'grey-60'
      },
      '&:last-of-type::after': {
        content: '""'
      }
    }
  }, rest), {}, {
    children: _jsx(Type.Hyperlink1, _objectSpread({
      sx: {
        marginX: '16px',
        color: ['grey-100', null, 'grey-80']
      },
      as: 'a',
      href: href
    }, rest))
  }));
};

export default LinkListItem;
//# sourceMappingURL=link-list-item.js.map